import React from 'react';
import { Link } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';

interface PremiumGateProps {
  moduleCode: string;
  children: React.ReactNode;
  /** When true, renders a compact inline badge instead of a block overlay (for use in navbars) */
  inline?: boolean;
}

/**
 * PremiumGate wraps premium features.
 * - If the module is accessible → renders children
 * - If inline mode (navbar) → hides the item entirely (no overlay in nav)
 * - Otherwise → renders a locked state with an upgrade prompt
 * Requirements: 10.1, 10.2, 10.3
 */
const PremiumGate: React.FC<PremiumGateProps> = ({ moduleCode, children, inline = false }) => {
  const { hasModule, loading } = useSubscription();

  if (loading) {
    return null;
  }

  if (!hasModule(moduleCode)) {
    // In inline/navbar mode, simply hide the item to avoid breaking the navigation layout
    if (inline) {
      return null;
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          textAlign: 'center',
          color: '#6b7280',
        }}
        aria-label={`Module ${moduleCode} non disponible`}
      >
        <span style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🔒</span>
        <p style={{ margin: '0 0 0.5rem' }}>
          Cette fonctionnalité nécessite un abonnement supérieur.
        </p>
        <Link
          to="/"
          style={{
            color: '#2563eb',
            textDecoration: 'underline',
            fontWeight: 500,
          }}
        >
          Mettre à niveau mon abonnement
        </Link>
      </div>
    );
  }

  return <>{children}</>;
};

export default PremiumGate;
